
import React from "react";
import { Schemes } from "../../../../../utils";
import { i18nManager } from "../../../../../i18n";
import { Elements } from "../../../../shared/Elements";
import { Siren } from "../../../../shared/ConfirmDialog";
import * as ReactRouterDom from "react-router-dom";
import { BaseService, IMember, ITeam, SanitizedResponse, TeamService } from "../../../../../services";
import { Button, FormControl, TextAreaInput } from "@rivtn/noseur";

export interface TeamRulesProps {
    team: ITeam;
    profile: IMember;
}

function TeamRules(props: TeamRulesProps) {

    const { team } = props;
    const teamService = TeamService.getInstance();
    const [profile, _] = React.useState<IMember>(props.profile);
    const labels = i18nManager.Labels.teams.settings.general.rules;
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);

    return (<div style={{ marginTop: 10, display: "flex", flexDirection: "column" }}>
        <FormControl isFieldset fill label={labels.team_rules} style={{ marginTop: 0 }}>
            <TextAreaInput style={{ height: 400 }} defaultValue={team.rule} fill onInputComplete={(value: string) => {
                team.rule = value;
            }} />
        </FormControl>
        <Button scheme={Schemes.OMNEHOST} loadingProps={Elements.BUTTON_LOADING_PROPS} text={labels.update_rules}
            style={{ marginTop: 30, padding: "10px 25px", alignSelf: "flex-end" }} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                teamService.updateTeam(team.external_id, { rule: team.rule }).then(({ sanitized }: SanitizedResponse<any>) => {
                    Siren.alert(labels.update_success);
                }).catch(BaseService.reportError).finally(() => {
                    e.manageRef?.setLoadingState(false);
                });
            }} />
    </div>);

}

export default TeamRules;
